/**------------------------------------------------------
 * Interface Definitions
 */
export interface IScaleLayoutHandler {
	getScaling: () => number;
	setScaling: (scale: number) => void;
}
